module.exports = __webpack_public_path__ + "static/media/manage-notice.cbbba0d4.svg";